import React, { Component } from "react";
import ReactToPrint from "react-to-print";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import ValeInfoContent from "component/ValeInfoContent/ValeInfoContent";
import Header from "component/Header/Header";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  dataLayer: {
    userId: "001",
    userProject: "project",
    page: "valeClass",
  },
  dataLayerName: "Vales",
};

class ComponentToPrint extends React.Component {
  render() {
    return <ValeInfoContent qr={true} />;
  }
}

class ValeClass extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}

  render() {
    TagManager.dataLayer(tagManagerArgs);

    const buttonSalir = (
      <Link to="/" style={{ textDecoration: "none", alignSelf: "center" }}>
        <Button
          variant="contained"
          style={{
            width: "50%",

            textTransform: "none",

            backgroundColor: "#F86436",
            color: "white",
          }}
          onClick={() => {
            localStorage.clear();
            sessionStorage.clear();
          }}
        >
          {" "}
          Salir
        </Button>
      </Link>
    );

    function GenerarNuevoVale() {
      localStorage.removeItem("valeType");
      localStorage.removeItem("idvale");
    }
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Header button={buttonSalir} />

        <br />
        <br />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <ComponentToPrint ref={(el) => (this.componentRef = el)} />
          <div style={{ alignSelf: "center", width: "100%" }}>
            <Container maxWidth="sm">
              <Grid container sx={{ width: "100%" }}>
                <Grid
                  size="grow"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Link
                    to="/vales"
                    style={{ textDecoration: "none", alignSelf: "center" }}
                  >
                    <Button
                      onClick={() => GenerarNuevoVale()}
                      variant="contained"
                      color="primary"
                      style={{
                        textTransform: "none",
                      }}
                    >
                      Generar nuevo vale
                    </Button>
                  </Link>
                </Grid>
                <Grid
                  size="grow"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      textDecoration: "none",
                      alignSelf: "center",
                      backgroundColor: "#F86436",
                    }}
                  >
                    <ReactToPrint
                      trigger={() => (
                        <a
                          style={{
                            color: "white",
                            textDecoration: "none",
                            textTransform: "none",
                            alignSelf: "center",
                          }}
                        >
                          Imprimir
                        </a>
                      )}
                      content={() => this.componentRef}
                    />
                  </Button>
                </Grid>
              </Grid>
            </Container>
          </div>
          <br />
          <div
            style={{
              backgroundColor: "#F9CDD0",
              border: "red 1px ridge",
              width: "60%",
              alignSelf: "center",
            }}
          >
            <Grid container sx={{ width: "100%" }}>
              <Grid size={{ xs: 1 }}>
                <ErrorRoundedIcon
                  fontSize="large"
                  color="secondary"
                  style={{ marginTop: "25%", marginLeft: "25%" }}
                />
              </Grid>
              <Grid size="grow">
                <p style={{ margin: "10px" }}>
                  IMPORTANTE: Descargá o realizá una captura de pantalla del
                  Vale antes de ingresar al establecimiento de vaciado.
                </p>
              </Grid>
            </Grid>
          </div>
          <br />
        </div>
      </div>
    );
  }
}
export default ValeClass;
